import EventBusInstance from '@core/eventbus';
import AudioService from '@services/AudioService';
import D3Throttle from '@utilities/throttle';

export type MatchAudioPluginOptions = {
  interval?: number;
  useMobileIcon?: boolean;
};

const defaults: MatchAudioPluginOptions = {
  interval: 30000,
  useMobileIcon: true,
};

export default class MatchAudioPlugin {
  options: MatchAudioPluginOptions;
  dom: HTMLPkButtonElement;
  throttle: D3Throttle<any>;

  constructor(dom: HTMLElement, options: MatchAudioPluginOptions) {
    this.options = {
      ...defaults,
      ...options,
    };

    this.dom = dom as HTMLPkButtonElement;

    setInterval(() => {
      this.checkAudioOpen();
    }, 1000);

    this.checkAudioOpen();
  }

  init() {
    if (this.options.useMobileIcon) {
      const events = ['orientationchange.audio', 'resize.audio'];
      this.throttle = new D3Throttle(window, this.checkWidth, undefined, events, this);
      this.checkWidth();
    }

    AudioService.subscribe(this.options.interval, this.onPoll, this);
  }

  onPoll = ({ active }: { active: boolean }) => {
    this.dom.classList.toggle('available', active);

    if (!active) return;

    this.triggerAnimation();
    setTimeout(() => {
      this.triggerAnimation();
    }, 5000);

    EventBusInstance.on('matchheader.affix', ({ isAffix }: { isAffix: boolean }) => {
      isAffix && this.triggerAnimation();
    });
  };

  checkAudioOpen() {
    this.dom.classList.toggle('hidden', AudioService.open);
  }

  checkWidth() {
    const isDesktop = screen.availWidth >= 960;
    this.dom.appearance = isDesktop ? 'outlined' : 'icon';
  }

  triggerAnimation() {
    this.dom.classList.add('animate');
    setTimeout(() => {
      this.dom.classList.remove('animate');
    }, 2000);
  }
}
